import { SETTINGS } from './environment'

global.API_BASE_URL = SETTINGS.API_BASE_URL
